import { render, staticRenderFns } from "./ListaReserva.vue?vue&type=template&id=2789cff0&"
import script from "./ListaReserva.vue?vue&type=script&lang=js&"
export * from "./ListaReserva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports